<div class="clock">
  <img src="/assets/bilder/anderes/wecker.webp" alt="wecker" class="clock">
</div>
